module.exports = __webpack_public_path__ + "static/media/24UHCHR14.49cf6817.jpg";